// extracted by mini-css-extract-plugin
export default {"flash-message":"FlashMessage_flash-message__-eL-i","success":"FlashMessage_success__P-oJx","fail":"FlashMessage_fail__+9uzW"};